module.exports = __webpack_public_path__ + "img/20210701.fca0e619.png";